import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    emptySearchTextWrapper: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(4, 1),
      backgroundColor: COLORS.gray.gray90,
      '& p': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    hint: {
      marginTop: theme.spacing(1),
      color: COLORS.gray.gray40,
    },
  }),
  { name: 'SearchHint' }
);
